import React, { useContext } from 'react';
import { Auth } from 'aws-amplify';
import { AuthContext } from 'appRoot/auth/AuthContext';
import { ChangePasswordForm } from 'screens/account/changePasswordScreen/ChangePasswordForm';
import { InnerWrapper } from 'profileManagement/InnerWrapper';
import { mapCognitoErrors } from 'appRoot/auth/mapCognitoErrors';

const ChangeTemporaryPasswordScreen = () => {
   const { challengedUser, setAuthState } = useContext(AuthContext);
   const [error, setError] = React.useState(null);

   const handleSubmit = async ({ newPassword }, formikHelpers) => {
      setError(null);
      try {
         const response = await Auth.completeNewPassword(challengedUser, newPassword);
         if (response?.challengeName === 'SOFTWARE_TOKEN_MFA') {
            setAuthState({ state: 'mfaChallenge', user: challengedUser });
         }
      } catch (err) {
         const raw =
            err?.__type ||
            err?.code ||
            err?.name ||
            err?.message ||
            (typeof err === 'string' ? err : 'An error occurred.');

         setError(mapCognitoErrors(raw));
         formikHelpers.setSubmitting(false);
      }
   };

   return (
      <div className="container">
         <InnerWrapper>
            <h1 className="mt-5 mb-3">Change Password</h1>

            {error && (
               <div className="alert alert-danger pl-3 mt-3">{error}</div>
            )}

            <p>Your temporary password must be changed to proceed.</p>

            <div className="mb-5">
               <ChangePasswordForm
                  onSubmit={handleSubmit}
                  showCurrentPassword={false}
               />
            </div>
         </InnerWrapper>
      </div>
   );
};

export { ChangeTemporaryPasswordScreen };
